import { FC } from 'react';
import AccordionContent from 'ui-kit/components/accordion/AccordionContent';
import { Transferor } from '../../types';
import TransferorForm from './TransferorForm';

interface TransferorAccordionProps {
  transferor: Transferor;
  index: number;
  onUpdate: (transferor: Transferor) => void;
  onDelete?: () => void;
}

const TransferorAccordion: FC<TransferorAccordionProps> = ({ transferor, index, onUpdate, onDelete }) => {
  const handleDelete = () => {
    onDelete?.();
  };

  return (
    <AccordionContent
      id={transferor.id || `transferor-${index}`}
      title={`Transferor No. ${index + 1}`}
      expanded={true}
      hideSubtitle={true}
      subtitle={[]}
      data-testid={`fincen-transferor-${index}-accordion`}
      data-testid-edit={`fincen-transferor-${index}-edit-button`}
      data-testid-delete={`fincen-transferor-${index}-delete-button`}
      onDelete={onDelete ? handleDelete : undefined}
    >
      <TransferorForm transferor={transferor} onUpdate={onUpdate} index={index} />
    </AccordionContent>
  );
};

export default TransferorAccordion;
